import styled from 'styled-components';
import {Box} from '@sproutsocial/seeds-react-box';
import {Button} from '@sproutsocial/seeds-react-button';
import {pollinateSproutLink} from '../pollination';
import {type TypeButtonData, type TypePageData} from '../services';

const OverflowButton = styled(Button)`
	white-space: normal;
	overflow-wrap: break-word;

	// custom font weight
	font-weight: 500;
`;

type TypeButtonsListProps = {
	page: TypePageData | null | undefined;
};

export default function ButtonsList({page}: TypeButtonsListProps) {
	if (!page?.buttons?.length) return null;

	const visibleButtons = page.buttons
		.filter(button => button.is_active)
		.sort((a, b) => a.button_order - b.button_order);

	if (!visibleButtons.length) return null;

	const {page_id} = page;

	const pollinateButtonClick = (buttonId: string) => {
		pollinateSproutLink({
			feature: 'button',
			action: buttonId,
			id: page_id,
		});
	};

	return (
		<Box display='flex' flexDirection='column' gap={350} pb={350}>
			{visibleButtons.map((button: TypeButtonData) => {
				const {button_display_text, destination_url, id} = button;

				return (
					<OverflowButton
						key={id}
						external
						size='large'
						appearance='secondary'
						href={destination_url}
						onClick={() => pollinateButtonClick(id)}
						mx={[450, 0]}
						// make the button a bit taller
						p={400}
					>
						{button_display_text}
					</OverflowButton>
				);
			})}
		</Box>
	);
}
